import moment from "moment";

const MINUTES_IN_HOUR = 60;

export const defaultFormat = (localDateTime) => {
    const date = moment(localDateTime);
    const formattedDate  = date.format("lll");
    return formattedDate
}

export const defaultFormatWithOutHours = (localDateTime) => {
    const date = moment(localDateTime);
    const formattedDate  = date.format("lll");
    return formattedDate
}

export function formatMinutesToDuration(totalMinutes) {
  if (typeof totalMinutes !== 'number' || totalMinutes < 0) {
      return "Duración inválida";
  }


  const duration = moment.duration(totalMinutes, 'minutes');
  const days = duration.days(); 
  const hours = duration.hours(); 
  
  const minutes = duration.minutes();

  const parts = [];

  if (days > 0) {
      parts.push(`${days} Día${days === 1 ? '' : 's'}`);
  }
  if (hours > 0) {
      parts.push(`${hours} Hora${hours === 1 ? '' : 's'}`);
  }
  if (minutes > 0 || parts.length === 0) { 
      parts.push(`${minutes} Minuto${minutes === 1 ? '' : 's'}`);
  }
  
  return parts.join(', ');
}

export function formatDaysAgo(numMin) {

  if (numMin >= MINUTES_IN_HOUR) {
      const numHours = Math.floor(numMin / MINUTES_IN_HOUR);
      return `${numHours} horas`;
    } else {
      return `${numMin} minutos`;
    }
  }

  export const customFormat = (date) => {
    return date.format("MMMM - YYYY");		
	};
  
  export const customLocalDateFormat = (date) => {
    return date.format("LL");		
	};

  export const customYearMonthFormat = (date) => {
    return date.format("MMM YYYY");		
	};
  